import {
  Table, TableBody, TableCell, TableContainer,
  TableFooter, TableHead,
  TablePagination, TableRow
} from '@material-ui/core';
import { ConvocadosResponse } from 'api/Assessor/convocados';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCPFOrCNPJ } from 'utils/cpfCnpjMask';
import useStyle from './style';






interface Props {
  relatorio: ConvocadosResponse;
  page: number;
  size: number;
  onChangePage: (page: number) => void;
  onChangeSize: (size: number, page: number) => void;
}

export default function ({ relatorio, page, size, onChangePage, onChangeSize }: Props) {
  const { t } = useTranslation();
  const classes = useStyle();

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, value: number) => {
    onChangePage(value + 1);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChangeSize(parseInt(event.target.value, 10), 1);
  };

  return (
    <TableContainer className={classes.root}>
      <Table>
        <TableHead className={classes.box}>
          <TableRow>
            <TableCell className={classes.title} align="center">
              {t('ConvocadosAssessor.tableHead.nomeConvocado')}
            </TableCell>
            <TableCell className={classes.title} align="center">
              {t('ConvocadosAssessor.tableHead.documento')}
            </TableCell>
            <TableCell className={classes.title} align="center">
              {t('ConvocadosAssessor.tableHead.coop')}
            </TableCell>
            <TableCell className={classes.title} align="center">
              {t('ConvocadosAssessor.tableHead.agencia')}
            </TableCell>
            <TableCell className={classes.title} align="center">
              {t('ConvocadosAssessor.tableHead.conta')}
            </TableCell>
            <TableCell className={classes.title} align="center">
              {t('ConvocadosAssessor.tableHead.saldoCotas')}
            </TableCell>
            <TableCell className={classes.title} align="center">
              {t('ConvocadosAssessor.tableHead.colaborador')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={classes.box}>
          {relatorio.elements.map((row, index) => (
            <TableRow key={`${index}-${row.cpfCnpj}`}>
              <TableCell className={classes.data} align="left">
                {row.nomeConvocado}
              </TableCell>
              <TableCell className={[classes.data, classes.noBreakingData].join(' ')} align="center">
                {formatCPFOrCNPJ(row.cpfCnpj)}
              </TableCell>
              <TableCell className={classes.data} align="center">
                {row.cooperativa}
              </TableCell>
              <TableCell className={classes.data} align="center">
                {row.codigoAgencia}
              </TableCell>
              <TableCell className={classes.data} align="center">
                {row.numeroConta}
              </TableCell>
              <TableCell className={classes.data} align="center">
                {row.saldoCotas.toString().replace('.', ',')}
              </TableCell>
              <TableCell className={classes.data} align="center">
                {t(`ConvocadosAssessor.colaborador.${row.colaborador}`)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              style={{ borderBottom: 'none' }}
              count={relatorio.totalElements}
              colSpan={9}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={size}
              page={page - 1}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelDisplayedRows={({ from, to, count }) =>
                t('ConvocadosAssessor.labelDisplayedRows', { from, to, count })
              }
              labelRowsPerPage={t('ConvocadosAssessor.labelRowsPerPage')}
              backIconButtonProps={{ className: classes.navIcon }}
              nextIconButtonProps={{ className: classes.navIcon }}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
